import React from "react";
import { Link } from "react-router-dom";
function Logo() {
  return (
    <div className="col-lg-2 col-7" style={{ textAlign: "-webkit-center" }}>
      <div className="logo">
        <Link to="/">
          <img
            src={process.env.PUBLIC_URL + "/images/logo.png"}
            alt=""
            title=""
            className="img-fluid"
          />
        </Link>
      </div>
    </div>
  );
}

export default Logo;
